import { ethers, BigNumber } from 'ethers';

export const SafeMath = {
    multiply: (a, b) => {
        try {
            return BigNumber.from(a).mul(BigNumber.from(b));
        } catch (error) {
            console.error('SafeMath multiplication error:', error);
            throw new Error('Invalid number operation');
        }
    },

    formatEther: (value) => {
        try {
            return ethers.utils.formatEther(BigNumber.from(value));
        } catch (error) {
            console.error('SafeMath format error:', error);
            throw new Error('Invalid number format');
        }
    },

    parseEther: (value) => {
        try {
            return ethers.utils.parseEther(value.toString());
        } catch (error) {
            console.error('SafeMath parse error:', error);
            throw new Error('Invalid ether value');
        }
    }
};